import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Layout } from '../layout/Layout';

import { getDataName } from './Panel.helpers';
import { type DataNameProps } from './Panel.types';

import './PanelCard.less';

const block = bemBlock('n-Panel');

export type PanelCardProps = React.HTMLAttributes<HTMLDivElement> & DataNameProps;

export const PanelCard = React.forwardRef<HTMLDivElement, PanelCardProps>(function PanelCard(
  { children, className, dataName, 'data-name': dataNameAttribute, ...passProps },
  ref,
) {
  return (
    <Layout.Element
      {...passProps}
      elementRef={ref}
      className={block({ element: 'card', extra: className })}
      data-name={getDataName(dataName, dataNameAttribute)}
    >
      {children}
    </Layout.Element>
  );
});
